import i18n from '../../../../../../lib/i18n';
import { formatCurrency } from '../../../../../../utils/currency-utils';
import LoadsConstants from '../../../constants';
import {
    LoadActionMap,
    LoadChangedAction,
    LoadHistoryStatusTmsMap,
} from '../../../enums/load-changed-action.enum';
import {
    CarrierMetadataResponse,
    ILoadHistoryEventResponse,
} from '../../../interfaces/ILoadHistoryResponse';
import { getFullTime, getLocalDate } from '../../../utils/loads-utils';

const getCurrency = (
    carrier: CarrierMetadataResponse,
    language: string | null,
): string | JSX.Element => {
    if (carrier.chargeAmount == null) {
        const label = i18n.t('LoadHistory.RoundSemConfirmacao');
        return (
            <b className="load-history-event-rate-without-confirmation">
                {label}
            </b>
        );
    }

    return formatCurrency(
        carrier.chargeAmount,
        carrier.currency && carrier.currency.trim() !== ''
            ? carrier.currency
            : 'BRL',
        language ?? 'pt-BR',
    );
};

const getCarrierLabel = (
    carrier: CarrierMetadataResponse,
    withCode?: boolean,
) => {
    const name =
        carrier.name === 'CarrierWithoutRegister'
            ? i18n.t('CarrierWithoutRegisterOnSulaHub')
            : carrier.name;

    return withCode ? `[${carrier.code}] ${name}` : name;
};

const translateMappedKey = (mappedKey: string | undefined, key: string) => {
    if (mappedKey === undefined) {
        return key;
    }

    return i18n.t(mappedKey);
};

const getEventLabel = (event: ILoadHistoryEventResponse): string => {
    const eventType = i18n.t(
        LoadActionMap[event.eventType as keyof typeof LoadChangedAction],
    );

    if (event.eventType === LoadChangedAction.StatusTmsUpdated) {
        const statusTms = translateMappedKey(
            LoadHistoryStatusTmsMap[event.metadata.statusTms],
            event.metadata.statusTms,
        );

        return `${eventType} | ${statusTms}`;
    }

    return eventType;
};

const getDateTimeLabel = (date: Date | undefined): string => {
    if (date === undefined) {
        return LoadsConstants.NO_INFO_TEXT;
    }

    return `${getLocalDate(date)?.toLocaleDateString()} | ${getFullTime(date)}`;
};

const LoadHistoryUtils = {
    getCurrency,
    getCarrierLabel,
    translateMappedKey,
    getEventLabel,
    getDateTimeLabel,
};

export default LoadHistoryUtils;
